<template>
  <div class="container">
    <el-upload
      class="avatar-uploader"
      action="123"
      :show-file-list="false"
      :on-success="handleSuccess"
      :on-change="onchange"
      :before-upload="beforeUpload"
    >
      <div
        v-if="backgroundImgUrl"
        :style="imgStyle"
        ref="capture"
        class="background-container"
      >
        <img
          class="background-img"
          :style="imgStyle"
          :src="backgroundImgUrl"
          alt=""
        />
        <img
          class="qrcode"
          :style="qrcodeStyle"
          :src="qrcodeUrl"
          alt=""
          srcset=""
        />
      </div>
      <i v-else :style="imgStyle" class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <div class="btn-container">
      <div class="qrcode-input">
        <label>二维码地址</label>
        <el-input v-model="inputImgUrl"></el-input>
        <el-button type="primary" @click="addQrcode" style="margin-left:20px"
          >插入</el-button
        >
      </div>
      <div class="row">
        <label>上下偏移</label>
        <el-input-number
          v-model="vertical"
          controls-position="right"
          :min="0"
        ></el-input-number>
      </div>
      <div class="row">
        <label>左右偏移</label>
        <el-input-number v-model="horizontal" :min="0"></el-input-number>
      </div>
      <div class="row">
        <label>背景图宽度</label>
        <el-input-number v-model="backgroundWidth" :min="400"></el-input-number>
      </div>
      <div class="row">
        <label>背景图高度</label>
        <el-input-number
          v-model="backgroundHeight"
          :min="400"
        ></el-input-number>
      </div>
      <div class="row">
        <label>二维码宽度</label>
        <el-input-number v-model="qrcodeWidth" :min="80"></el-input-number>
      </div>
      <div class="row">
        <label>二维码高度</label>
        <el-input-number v-model="qrcodeHeight" :min="80"></el-input-number>
      </div>
      <el-button type="primary" @click="generatorImage" class="img-btn"
        >生成图片</el-button
      >
    </div>
  </div>
</template>

<script>
import request from "../../api/request";
import html2canvas from "html2canvas";
export default {
  name: "ChatRoomList",
  data() {
    return {
      backgroundImgUrl: "",
      backgroundWidth: 400,
      backgroundHeight: 400,
      qrcodeWidth: 80,
      qrcodeHeight: 80,
      vertical: 0,
      horizontal: 0,
      qrcodeUrl: "",
      inputImgUrl: ""
    };
  },
  created() {},
  computed: {
    // 计算属性的 getter
    imgStyle() {
      return {
        width: this.backgroundWidth + "px",
        height: this.backgroundHeight + "px",
        "line-height": this.backgroundHeight + "px"
      };
    },
    qrcodeStyle() {
      return {
        height: this.qrcodeHeight + "px",
        width: this.qrcodeWidth + "px",
        top: this.vertical + "px",
        left: this.horizontal + "px"
      };
    }
  },
  methods: {
    handleSuccess(res, file) {
      this.backgroundImgUrl = URL.createObjectURL(file.raw);
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    //当上传图片后，调用onchange方法，获取图片本地路径
    onchange(file) {
      const localFile = file.raw;
      const reader = new FileReader();
      reader.readAsDataURL(localFile);
      reader.onload = e => {
        this.backgroundImgUrl = e.target.result;
      };
    },
    generatorImage() {
      html2canvas(this.$refs.capture, {
        useCORS: true,
        scale: 3,
        removeContainer: true
      }).then(canvas => {
        let link = document.createElement("a");
        link.href = canvas.toDataURL();
        link.setAttribute("download", "海报.png");
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
      });
    },
    async addQrcode() {
      if (this.inputImgUrl) {
        const resp = await request.tools.post("qr_code_img_get", {
          url: encodeURIComponent(this.inputImgUrl) 
        });
        this.qrcodeUrl = `data:image/png;base64,${resp.data.image}`
      }
    }
  }
};
</script>

<style scoped>
.container {
  padding-left: 20px;
  display: flex;
  flex-direction: row;
}
.btn-container {
  padding-left: 30px;
}
.row {
  margin-bottom: 20px;
}
label {
  margin-right: 20px;
  flex: 1 0 auto;
}
.background-container {
  overflow: hidden;
}
.background-img {
  position: relative;
  z-index: 1;
}
.qrcode-input {
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-bottom: 20px;
}
.qrcode {
  position: absolute;
  height: 80px;
  width: 80px;
  z-index: 20;
}

</style>
